// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__7RZJw","item":"PaymentsMobile_item__2vNfP","label":"PaymentsMobile_label__3vWpA","amount":"PaymentsMobile_amount__2Q_gq"};